module.exports = __webpack_public_path__ + "img/Half Active.e7c2da92.svg";